import React, { Component } from "react";
import Menu from "./Menu";

class AdvancedSearch extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      defaultTab: props.search ? "Advanced Search" : "All Products",
    };
  }

  render() {
    return (
      <Menu activeTab={this.state.defaultTab} search={this.props.search} />
    );
  }
}

AdvancedSearch.TABS = {
  ALL_PRODUCTS: "All Products",
  ADVANCED_SEARCH: "Advanced Search",
};

export default AdvancedSearch;
